// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
}

.success-modal {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: popIn 0.4s ease-out;
}

.success-icon {
  margin-bottom: 20px;
  animation: scaleIn 0.6s ease-out;
}

.success-icon svg {
  filter: drop-shadow(0 4px 8px rgba(76, 175, 80, 0.2));
}

.success-title {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #2e7d32;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.success-details {
  margin: 20px 0 30px 0;
}

.success-message {
  font-size: 14px;
  color: #555;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.user-info {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 15px;
  margin: 20px 0;
  border-left: 4px solid #4caf50;
}

.user-info label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.user-id-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: 8px;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  gap: 8px;
}

.user-id-box code {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  font-weight: 600;
  color: #2e7d32;
  flex: 1 1;
  text-align: left;
  letter-spacing: 0.5px;
}

.copy-btn {
  background: #e8f5e9;
  color: #2e7d32;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.copy-btn:hover {
  background: #c8e6c9;
  transform: scale(1.05);
}

.copy-btn:active {
  transform: scale(0.98);
}

.next-steps {
  font-size: 12px;
  color: #888;
  margin: 15px 0 0 0;
  line-height: 1.5;
}

.success-button {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  font-family: 'Poppins', sans-serif;
}

.success-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
}

.success-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 600px) {
  .success-modal {
    padding: 30px 20px;
    margin: 20px;
  }

  .success-title {
    font-size: 20px;
  }

  .success-icon svg {
    width: 60px;
    height: 60px;
  }

  .user-id-box {
    flex-direction: column;
    align-items: stretch;
  }

  .copy-btn {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SuccessModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".success-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.success-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  max-width: 450px;\n  width: 90%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  animation: popIn 0.4s ease-out;\n}\n\n.success-icon {\n  margin-bottom: 20px;\n  animation: scaleIn 0.6s ease-out;\n}\n\n.success-icon svg {\n  filter: drop-shadow(0 4px 8px rgba(76, 175, 80, 0.2));\n}\n\n.success-title {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #2e7d32;\n  margin: 0 0 20px 0;\n  line-height: 1.4;\n}\n\n.success-details {\n  margin: 20px 0 30px 0;\n}\n\n.success-message {\n  font-size: 14px;\n  color: #555;\n  margin: 0 0 20px 0;\n  line-height: 1.6;\n}\n\n.user-info {\n  background: #f5f5f5;\n  border-radius: 12px;\n  padding: 15px;\n  margin: 20px 0;\n  border-left: 4px solid #4caf50;\n}\n\n.user-info label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.user-id-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n  border-radius: 8px;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  gap: 8px;\n}\n\n.user-id-box code {\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2e7d32;\n  flex: 1;\n  text-align: left;\n  letter-spacing: 0.5px;\n}\n\n.copy-btn {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.copy-btn:hover {\n  background: #c8e6c9;\n  transform: scale(1.05);\n}\n\n.copy-btn:active {\n  transform: scale(0.98);\n}\n\n.next-steps {\n  font-size: 12px;\n  color: #888;\n  margin: 15px 0 0 0;\n  line-height: 1.5;\n}\n\n.success-button {\n  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n  font-family: 'Poppins', sans-serif;\n}\n\n.success-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);\n}\n\n.success-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  .success-modal {\n    padding: 30px 20px;\n    margin: 20px;\n  }\n\n  .success-title {\n    font-size: 20px;\n  }\n\n  .success-icon svg {\n    width: 60px;\n    height: 60px;\n  }\n\n  .user-id-box {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .copy-btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
